import { Grid } from '@mui/material'
import { RedirectButton, PageLayoutWithTitleAndInfo } from '../../../components'
import { GET_MEMBERSHIP_FEES } from '../../../graphql'
import { useStateWrapper, useUserRenderWrapper } from '../../../hooks'
import { ROUTE_MEMBERSHIP_FEES } from '../../../routes/constants/routeConstants'
import { MembershipFeesQueryType } from '../../../types'
import { PaymentInfoProvider } from './contexts'
import { AlertProvider } from '../../../contexts'
import {
  AccrualBases,
  CalculateMembershipFeeForm,
  MembershipFeePaymentInfo,
  MembershipFeePaymentOptions
} from './components'

export const CalculateMembershipFee = () => {
  const { StateRenderWrapper, data: membershipFees } =
    useStateWrapper<MembershipFeesQueryType>({
      query: GET_MEMBERSHIP_FEES
    })

  const { user, UserRenderWrapper } = useUserRenderWrapper()

  return (
    <PageLayoutWithTitleAndInfo
      infoBoxProps={{
        translationId:
          'pages.membershipFeesPage.calculateMembershipFeePage.infoBoxText'
      }}
      titleTranslationTopId="pages.membershipFeesPage.calculateMembershipFeePage.title"
      topElement={
        <Grid container justifyContent="flex-end">
          <Grid item>
            <RedirectButton
              redirectPath={ROUTE_MEMBERSHIP_FEES}
              translationId="common.return"
            />
          </Grid>
        </Grid>
      }
    >
      <StateRenderWrapper>
        {membershipFees && (
          <PaymentInfoProvider>
            <Grid
              container
              columnSpacing={{ md: 4 }}
              rowSpacing={{ xs: 4 }}
              pt={2}
            >
              <Grid item md={9} xs={12}>
                <UserRenderWrapper>
                  {user && (
                    <AlertProvider>
                      <CalculateMembershipFeeForm
                        membershipFees={membershipFees}
                        user={user}
                      />
                    </AlertProvider>
                  )}
                </UserRenderWrapper>
              </Grid>
              <Grid item md={3} xs={12}>
                <AccrualBases membershipFees={membershipFees} />
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={12} xs={12}>
                <MembershipFeePaymentInfo
                  bankAccounts={membershipFees.bankAccounts}
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <MembershipFeePaymentOptions />
              </Grid>
            </Grid>
          </PaymentInfoProvider>
        )}
      </StateRenderWrapper>
    </PageLayoutWithTitleAndInfo>
  )
}
